module.exports = __webpack_public_path__ + "static/media/Bicocca - LT GRAY - 9901_9946_9509_9355.122895ad.jpg";